import syncFields from '../_syncfields.js';
import reportModified from '../_reportmodified.js';
import assign from '../../_helpers/assign.js';
import toAbsoluteIndex from '../_toabsoluteindex.js';
import { checkCompatRenderer } from '../_processrendering/checkbeforechange.js';
export default function createFill(hasOptions) {
  return function fill(value, start, end) {
    var _syncFields = syncFields(this),
      itemMediator = _syncFields.itemMediator;
    var argsLength = arguments.length - +hasOptions;
    var givenEventOptions = hasOptions ? arguments[arguments.length - 1] : null;
    var useMediator = typeof itemMediator === 'function' && !(givenEventOptions != null && givenEventOptions.skipItemMediator);
    var length = this.length;
    var from = toAbsoluteIndex(argsLength > 1 ? start : undefined, length);
    var to = toAbsoluteIndex(argsLength > 2 ? end : undefined, length, length);
    var added = [];
    var removed = [];
    // an empty range changes nothing, so nothing is reported
    if (from >= to) {
      return this;
    }
    checkCompatRenderer(this, 'fill', givenEventOptions);
    for (var i = from; i < to; i++) {
      var item = useMediator ? itemMediator(value, i) : value;
      removed.push(this[i]);
      added.push(item);
      this[i] = item;
    }
    var eventOptions = {
      method: 'fill',
      self: this,
      added: added,
      removed: removed
    };
    // extend event options by custom event options if they are given
    if (hasOptions) {
      if (givenEventOptions && typeof givenEventOptions === 'object') {
        assign(eventOptions, givenEventOptions);
      }
    }
    reportModified(this, eventOptions);
    return this;
  };
}